import React, { Component } from "react";
import { navigate } from "../../store/navigation/operations";
import { connect } from "react-redux";

class ReduxLinkDecorator extends Component {
  goTo = () => {
    this.props.navigate(`/${this.props.goTo}`);
  };

  render() {
    let children = React.Children.map(this.props.children, (child, index) => {
      return React.cloneElement(child, { onClick: this.goTo });
    });

    return <>{children}</>;
  }
}

const mapDispatchToProps = dispatch => ({
  navigate: to => dispatch(navigate(to))
});

export default connect(
  null,
  mapDispatchToProps
)(ReduxLinkDecorator);
